import { blue, grey } from '@mui/material/colors'
import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  typography: {
    fontFamily: ['Inter', 'Montserrat', 'sans-serif'].join(','),
    button: {
      textTransform: 'none',
    },
  },
  palette: {
    text: {
      disabled: 'rgba(0, 0, 0, 0.6)',
    },
  },
  components: {
    MuiFormLabel: {
      styleOverrides: {
        asterisk: { color: '#ac0023' },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderWidth: '3px',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#1d537f',
          },
        },
        notchedOutline: {
          borderColor: '#277ec5',
          borderWidth: '2px',
        },
      },
    },

    MuiButton: {
      defaultProps: {},
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.variant === 'contained' && {
            background: 'linear-gradient(180deg, #43B651 0%, #225B29 100%)',
            color: 'white',
            ...(ownerState.disabled && {
              background: grey[600],
            }),
            '&:hover': {
              background: 'linear-gradient(180deg, #2d993a 0%, #114c18 100%)',
            },
          }),
          ...(ownerState.variant === 'outlined' && {
            background: 'linear-gradient(180deg, #66b0ec 0%, #105a97 100%)',
            color: 'white',
            ...(ownerState.disabled && {
              background: grey[600],
            }),
            '&:hover': {
              background: 'linear-gradient(180deg, #4a8abd 0%, #0e4e81 100%)',
            },
          }),

          ...(ownerState.color === 'warning' && {
            background: 'linear-gradient(180deg, #eb9651 0%, #ed6c02 100%)',
            color: 'white',
            ...(ownerState.disabled && {
              background: grey[600],
            }),
            '&:hover': {
              background: 'linear-gradient(180deg, #ed6c02 0%, #b14f00 100%)',
            },
          }),
        }),
      },
    },

    MuiTextField: {
      styleOverrides: {
        root: {
          backgroundColor: 'white',
        },
      },
    },
  },
})

export default theme
